import { render } from "./EmbedHeaderViewButtons.vue?vue&type=template&id=74e476c7"
import script from "./EmbedHeaderViewButtons.vue?vue&type=script&lang=js"
export * from "./EmbedHeaderViewButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__